const basePath = 'https://benefit-api.v4.kimbocare.dev';
const paymentBasePath = 'https://kimbo-dev.ddns.net/payment-api';
const authBasePath = 'https://kimbo-dev.ddns.net/auth';
const deeplApiKey = 'c33fc85c-93ff-4d12-a52c-130787e20571:fx';
export const environment = {
  production: true,
  serviceWorker: true,
  appId: 'benefit',
  vapidKey:
    'BI-9ryhqMrssYqhg5evENqNEzkBQTDK95eTca6d0DtP-fx5xDlwgnlayzZmu2P66IrT2PoDcS8S3NTp_Mjj8Hi8',
  google_client_id:
    '100180207220-7po6nvcajccccoalkr61k3me4uk2s8r1.apps.googleusercontent.com',
  deeplApiKey,
  name: 'staging',
  appVersion: require('../../package.json').version,
  badge: true,
  basePath,
  paymentBasePath,
  authBasePath,
  apiProvider: 'api',
  sentry: {
    tracingOrigins: ['https://app.kimbocare.dev'],
  },
  recaptcha: {
    siteKey: '6LcRPTYmAAAAAArMl6NN16N_kXQaVOT7EGgczl5d',
  },
  ssk: 'we-sv-rtw--eüd-§$-fd',
  ssv: 'öer:gerv:vjdf+*dfe#e-ee,',
};
